// Lists read a page at a time (list caps, BL-110): how many of the server's total are shown beside a
// list's "Load more", and every page of a list read one after another, for a sum or a picker that
// needs all of it.

/** "100 of 1,340 shown"; never fewer in all than are shown (a row added since the count). */
export const shownText = (shown: number, total: number) =>
  `${shown.toLocaleString('en-CA')} of ${Math.max(shown, total).toLocaleString('en-CA')} shown`;

/**
 * Every page of a list, read one after another until `next` runs out: for a picker over a few hundred
 * rows, or a sum over every row. `pages` stops a cursor that never ends.
 */
export async function everyPage<R, C>(
  read: (after: C | null) => Promise<{ items: R[]; next: C | null }>,
  pages = 50,
): Promise<R[]> {
  const got: R[] = [];
  let after: C | null = null;
  for (let n = 0; n < pages; n++) {
    const p: { items: R[]; next: C | null } = await read(after);
    got.push(...p.items);
    if (!p.next) break;
    after = p.next;
  }
  return got;
}
